import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { Well } from '@tanium/react-well';
import { ThemeColors } from '@tanium/theme-data';
import { Button } from '@tanium/react-button';
import TaniumLogo from '../../static/tanium_logo.svg';
import { HeaderBoldText, MediumText } from '../../TextStyles';

const HEADER = 'Notice and Consent';
const NOTICE =
  'You are accessing a U.S. Government (USG) Information System (IS) that is provided for USG-authorized use only.';
const CONSENT_INTRO =
  'By using this IS (which includes any device attached to this IS), you consent to the following conditions:';
const CONSENT_CONDITIONS: ReadonlyArray<string> = [
  'The USG routinely intercepts and monitors communications on this IS for purposes including, but not limited to, penetration testing, COMSEC monitoring, network operations and defense, personnel misconduct (PM), law enforcement (LE), and counterintelligence (CI) investigations.',
  'At any time, the USG may inspect and seize data stored on this IS.',
  'Communications using, or data stored on, this IS are not private, are subject to routine monitoring, interception, and search, and may be disclosed or used for any USG-authorized purpose.',
  'This IS includes security measures (e.g., authentication and access controls) to protect USG interests—not for your personal benefit or privacy.',
];
const AGREEMENT =
  'Notwithstanding the above, using this IS does not constitute consent to PM, LE, or CI investigative searching or monitoring of the content of privileged communications, or work product, related to personal representation or services by attorneys, psychotherapists, or clergy, and their assistants. Such communications and work product are private and confidential. See User Agreement for details.';

export const NoticeAndConsent: React.VFC<{ onAgreementClick: () => void }> = ({ onAgreementClick }) => {
  const { t } = useTranslation();

  return (
    <Box as={Stack} borderRadius="8px" minHeight="547px" width="1284px" boxShadow="Overlay2">
      <Box borderLeftRadius="8px" bg={ThemeColors.Dark0} height="100%" width="442px" display="flex" alignItems="center">
        <img src={TaniumLogo} alt={t('Tanium logo')} height="60px" width="100%" />
      </Box>
      <Box borderRightRadius="8px" bg={ThemeColors.FillLevel2} height="100%" width="843px" alignItems="left">
        <Well>
          <Stack justifyContent="left" direction="column" itemSpacing={3}>
            <HeaderBoldText>{t(HEADER)}</HeaderBoldText>
            <Stack justifyContent="left" direction="column" itemSpacing={2}>
              <MediumText>{t(NOTICE)}</MediumText>
              <MediumText>{t(CONSENT_INTRO)}</MediumText>
              <Well>
                <Stack justifyContent="left" direction="column" itemSpacing={2}>
                  {CONSENT_CONDITIONS.map((c) => (
                    <li key={c}>
                      <MediumText>{t(c)}</MediumText>
                    </li>
                  ))}
                </Stack>
              </Well>
              <MediumText>{t(AGREEMENT)}</MediumText>
            </Stack>
          </Stack>
          <Box as={Stack} justifyContent="center" mt={4}>
            <Button variant="primary" onClick={onAgreementClick}>
              <Box width="300px"> {t('Agree')}</Box>
            </Button>
          </Box>
        </Well>
      </Box>
    </Box>
  );
};
